<template>
  <v-container>
    <page-heading>{{ pageTitle }}</page-heading>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title><div v-if="notifications.numberOfActive > 0" class="text-h3 mr-2">{{ notifications.numberOfActive || '0' }}</div> {{ transc('notifications.numberOfActive', notifications.numberOfActive) }}</v-card-title>
          <v-card-text>
            <request-state :request-promise="activeNotificationsRequest" :always-show="true">
              <notifications-list
                :active-notifications="notifications.activeNotifications"
                @update="getActiveNotifications"
              />
            </request-state>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-card-title><div v-if="numberOfOpenCancellations > 0" class="text-h3 mr-2">{{ numberOfOpenCancellations || '0' }}</div> {{ transc('dashboard.numberOfOpenCancellations', numberOfOpenCancellations) }}</v-card-title>
          <v-card-text>
            <ajax-table
              ref="bookingsTable"
              :resource="bookingsResourceUrl"
              :headers="[
                {text: 'booking.bookingId', value: 'id'},
                {text: 'booking.status', value: 'status'},
                {text: 'object.object', value: 'objectName'},
                {text: 'booking.checkinAt', value: 'checkinAt'},
                {text: 'booking.checkoutAt', value: 'checkoutAt'},
              ]"
              :page-options="{itemsPerPage: 5, sortBy: ['id'], sortDesc: [true]}"
              :items-per-page-options="[10, 20, 50, 100]"
              :filter="bookingsFilter"
              @page-loaded="onBookingOpenCancellationsPageLoaded"
              no-elevation
              hide-default-footer
            >
              <template v-slot:item.id="{ item }">
                <booking-id :value="item" :open-in-new-tab="false" />
              </template>
              <template v-slot:item.status="{ item }">
                <status-badge v-if="item.disabled" color="red lighten-3">{{ trans('general.deleted') }}</status-badge>
                <booking-status v-else :booking="item"/>
              </template>
              <template v-slot:item.objectName="{ item }">
                <object-name :value="item" />
              </template>
            </ajax-table>
            <div v-if="numberOfOpenCancellations === 0" class="d-flex justify-center align-center mb-5">
              <v-icon color="grey lighten-2" size="100">mdi-book-check</v-icon>
            </div>
          </v-card-text>
          <v-card-actions v-if="numberOfOpenCancellations > 0">
            <v-spacer></v-spacer>
            <v-btn text @click="pushToRoute('Bookings', null, {onlyCanceledInStayin: true})" class="mr-1">
              <v-icon left small>mdi-magnify</v-icon>
              {{ trans('general.showAll') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageHeading from '@/components/PageHeading';
import {LocaleUtils} from '@/utils/locale-utils';
import NotificationsList from '@/components/notifications/NotificationsList';
import {NotificationUtils} from '@/utils/notification-utils';
import RequestState from '@/components/RequestState';
import {BookingApi} from '@/api/booking-api';
import {comparison, eq, inList} from 'rsql-builder';
import AjaxTable from '@/components/AjaxTable';
import BookingId from '@/components/BookingId';
import BookingStatus from '@/components/BookingStatus';
import ObjectName from '@/components/ObjectName';
import {RouterUtils} from '@/utils/router-utils';
import StatusBadge from '@/components/StatusBadge';

export default {
  name: 'DashboardPage',
  mixins: [
    LocaleUtils,
    NotificationUtils,
    RouterUtils
  ],
  components: {
    StatusBadge,
    ObjectName,
    BookingStatus,
    BookingId,
    AjaxTable,
    RequestState,
    NotificationsList,
    PageHeading
  },
  data () {
    return {
      activeNotificationsRequest: null,
      numberOfOpenCancellations: null,
      bookingOpenCancellations: null
    }
  },
  computed: {
    pageTitle () {
      return this.trans('dashboard.dashboard');
    },

    bookingsResourceUrl () {
      return BookingApi.apiUri;
    },

    bookingsFilter () {
      let filters = [];
      filters.push(comparison('onlyCanceledInStayin', eq(true)));
      return filters;
    },
  },
  mounted () {
    this.getActiveNotificationsInternal();
  },
  activated () {
    this.$nextTick(() => {
      try {
        this.$refs.bookingsTable.loadData();
      } catch (e) { console.warn(e); }
    });
  },
  methods: {
    getActiveNotificationsInternal () {
      this.activeNotificationsRequest = this.getActiveNotifications();
    },
    onBookingOpenCancellationsPageLoaded (page) {
      this.numberOfOpenCancellations = page.totalElements;
    }
  }
}
</script>

<style scoped>

</style>
